export const defaultInput = {
  name: '',
  description: '',
  short: '',
  tags: []
};